import styled from "styled-components";
import { ScanCow, ScanCrackerModal } from "../../assets/images";
import { useState } from "react";
import { CloseWhite } from "../../assets/icons";

const TCModal = ({ onClose }) => {
  return (
    <StyledTCModal>
      <div>
        <ModalContent>
          <ModalHeaderContainer>
            <CloseButton onClick={onClose}>
              <CloseIcon src={CloseWhite} />
            </CloseButton>
          </ModalHeaderContainer>
          <ModalHeader>Terms & Conditions</ModalHeader>
          <ol>
          <li>
          Every device is limited to one scan every 3 days</li>
          <li>All Free & discounted tickets can only be purchased online through Al Maha web portal and are not available for purchase at the door</li>
          <li>Prizes can only be redeemed through AL Maha web portal, not at the door</li>
          <li>Tickets are valid during week days & weekends during the regular Lusail Winter Wonderland opening hours</li>
          <li>Prizes are non-transferable and cannot be exchanged for cash or any other items</li>
          <li>The promotion is applicable on ‘Unlimited Rides packages’ only</li>
          <li>Baladna & Lusail Winter Wonderland is not responsible for any technical issues, including but not limited to QR code scanning errors or platform misfunctions</li>
          <li>The Promotion is valid from 1 Nov until 30 Nov 2024</li>
 
          </ol>
        </ModalContent>
      </div>
    </StyledTCModal>
  );
};

const CloseIcon = styled.img`
  width: 1.5rem;
  height: 1.5rem;
`;

const CloseButton = styled.button`
  background: transparent;
  outline: none;
  border: none;
`;

const ModalHeaderCow = styled.div`
  display: flex;
  width: 100%;
  height: fit-content;
  object-fit: cover;
  background-image: url(${ScanCrackerModal});
  background-position: center center;
  justify-content: center;
  padding-top: 3rem;
`;

const StyledTCModal = styled.div`
  height: 100vh;
  max-height: 100vh;
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 9;
  overflow-y: auto;
  display:flex;
  justify-content:center;
  align-items:center;
  > div {
    background: rgba(0, 0, 0, 0.75);
    overflow-y: auto;
    width: 100%;
    height: 90%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
  }
`;

const VerifyOtpInput = styled.input`
  border-radius: 0.5rem;
  background: #fcfdfe;
  border: 1px solid #eee;
  width: 2.5rem;
  height: 2.5rem;
  font-family: "Poppins";
  font-size: 2rem;
  text-align: center;
`;

const ModalContent = styled.div`
  height: 85%;
  width: 85%;
  background: #1c1d21;
  border-radius: 0.5rem;
  padding: 1rem;
  text-align: center;
  gap: 0.5rem;
  display: flex;
  flex-direction: column;
  // justify-content: center;
  align-items: center;
  overflow-y: auto;

  > ol {
    padding-left: 0.5rem;
    color:grey;
    text-align:left;
  }
  > ol > li {
    padding: 0.5rem 0;
  }
`;

const VerifyOtpContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 0;
  max-width: 20rem;
  gap: 1rem;
`;

const ModalHeaderContainer = styled.div`
  text-align: right;
  width: 100%;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: end;
`;

const DidNotReceive = styled.div`
  color: white;
  font-size: 1rem;
  font-weight: 300;
`;

const ResendText = styled.div`
  color: aqua;
  font-size: 1rem;
  font-weight: 300;
`;

const EnterOTPText = styled.div`
  color: #9b9b9b;
  font-size: 1rem;
  font-weight: 300;
`;

const ModalHeader = styled.div`
  color: white;
  font-size: 1.25rem;
  font-weight: 500;
`;

const SpinWheelModalCow = styled.img`
  width: 6rem;
`;

export default TCModal;
